import { GetJobStatusRequestParams, GetJobStatusResponse } from '@upright/common/internal/jobs/api-types';
import { UpdateStepId } from '@upright/common/model/update/types';
import { stringify } from 'querystring';
import { Job, JobCount, JobStatus, JobStatusResponse, JobType } from '../../../../common/internal/jobs/types';
import { NumberHash } from '../../../../common/utils/number-hash/types';
import { fetchOrThrow } from '../../common/fetchers/fetch-or-throw';
import { fetchApiWithError } from '../../common/fetchers/fetch-with-error';
import { getFromApi } from '../../common/fetchers/request-api';

export async function fetchJobCounts(type: JobType) {
  return await getFromApi<NumberHash>(`/job-counts/${type}`);
}

export async function fetchAllJobCounts() {
  return await fetchApiWithError<JobCount[]>(`/job-counts-all`, 'GET', undefined);
}

export async function fetchJobs(
  type: JobType | undefined,
  status: JobStatus | undefined,
  limit: number,
  parentId?: number,
) {
  const params = {
    type,
    status,
    limit,
    parentId,
  };
  return await fetchApiWithError<Job[]>(`/jobs?${stringify(params)}`, 'GET', undefined);
}

export async function fetchModelUpdateStepJobs(limit: number) {
  return await fetchApiWithError<Job[]>(`/model-update-jobs?limit=${limit}`, 'GET', undefined);
}

export async function fetchJob(jobId: number) {
  return await fetchApiWithError<Job>(`/job/${jobId}`, 'GET', undefined);
}

export async function fetchJobWithChildren(jobId: number) {
  return await fetchApiWithError<Job[]>(`/job-with-children/${jobId}`, 'GET', undefined);
}

export async function updateJobStatuses(type: JobType, currentStatus: JobStatus, targetStatus: JobStatus) {
  return await fetchApiWithError<JobStatusResponse>(
    `/jobs/update-status/${type}/${currentStatus}/${targetStatus}`,
    'POST',
    undefined,
  );
}

export async function deleteJobs(type: JobType, status: JobStatus) {
  return await fetchApiWithError<JobStatusResponse>(`/jobs/${type}/${status}`, 'DELETE', undefined);
}

export async function fetchJobStatus(params: GetJobStatusRequestParams) {
  return await fetchOrThrow<GetJobStatusResponse>(`/job/${params.jobId}/status`);
}

export async function skipModelUpdateStep(jobId: number, stepId: UpdateStepId) {
  return await fetchApiWithError<Job>(
    `/jobs/model-update/${jobId}/steps/${encodeURIComponent(stepId)}/skip`,
    'POST',
    undefined,
  );
}
